module.exports = __webpack_public_path__ + "static/media/background.f747855a.png";